module.exports = __webpack_public_path__ + "media/images/payments/apple_subscription-c7021c42412542b14918e3d52ce94f62.png";